import React from "react";
import { Outlet } from "react-router-dom";

const LogisticsOutlet = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default LogisticsOutlet;
